import { combineReducers } from 'redux'

import { reducer as add } from './add'
import { reducer as getTraineesBySector } from './getTraineesBySector'
import { reducer as uploadProjetPublic } from './uploadProjetPublic'
import { reducer as deleteTraineesBySector } from './deleteTraineesBySector'
import { reducer as editTraineesBySector } from './editTraineesBySector'
import { reducer as getOneTraineesBySector } from './getOneTraineesBySector'
import { reducer as getBtsHistory } from './getBtsHistory'
import { reducer as deleteBtsHistory } from './deleteBtsHistory'
import { reducer as getSocioEcoHistory } from './getSocioEcoHistory'
import { reducer as deleteSocioEcoHistory } from './deleteSocioEcoHistory'
import { reducer as getPublicProjectHistory } from './getPublicProjectHistory'
import { reducer as deletePublicProjectHistory } from './deletePublicProjectHistory'
import { reducer as deleteSocioEco } from './deleteSocioEco'
import { reducer as editSocioEco } from './editSocioEco'

export default combineReducers({
    add,
    getTraineesBySector,
    uploadProjetPublic,
    deleteTraineesBySector,
    editTraineesBySector,
    getOneTraineesBySector,
    getBtsHistory,
    deleteBtsHistory,
    getSocioEcoHistory,
    deleteSocioEcoHistory,
    getPublicProjectHistory,
    deletePublicProjectHistory,
    deleteSocioEco,
    editSocioEco,
})
